import { MT_MODULES } from './constants';
import { MODULE_LINK_TYPE } from './constants';

import * as URLS from './modules';

const MODULES_LINK_MAP = {
  [MT_MODULES.ILT]: URLS.ILT,
  [MT_MODULES.COURSE]: URLS.COURSE,
  [MT_MODULES.MISSION]: URLS.MISSION,
  [MT_MODULES.CHECKLIST]: URLS.CHECKLIST,
  [MT_MODULES.ASSESSMENT]: URLS.ASSESSMENT,
  [MT_MODULES.QUICKUPDATE]: URLS.QUICK_UPDATE,
  [MT_MODULES.REINFORCEMENT]: URLS.REINFORCEMENT,
  [MT_MODULES.AI_ROLEPLAY]: URLS.AI_ROLEPLAY,
  [MT_MODULES.ONE_TO_ONE_COACHING]: URLS.ONE_TO_ONE_COACHING,
  [MT_MODULES.VIDEO_PITCH_COACHING]: URLS.VIDEO_PITCH_COACHING,
  [MT_MODULES.COMPETENCY_ASSESSMENT]: URLS.COMPETENCY_ASSESMENT,
  [MT_MODULES.SCREEN_CAPTURE_COACHING]: URLS.SCREEN_CAPTURE_COACHING,
  [MT_MODULES.TASK_EVALUATION_COACHING]: URLS.TASK_EVALUATION_COACHING,
  [MT_MODULES.VOICE_OVER_PPT_COACHING]: URLS.VOICE_OVER_PPT_COACHING,
};

function getModuleAccessLinkGenerator(
  type: keyof typeof MODULES_LINK_MAP,
  forAdmin: boolean = true
) {
  if (!MODULES_LINK_MAP[type]) {
    throw new Error(`missing urls for module type ${type}`);
  }
  const generator = forAdmin ? MODULES_LINK_MAP[type].ADMIN : MODULES_LINK_MAP[type].LEARNER;
  return generator;
}

export default getModuleAccessLinkGenerator;

export { MODULE_LINK_TYPE as URL_TYPES, MODULES_LINK_MAP };
